import React, { useState, useEffect } from 'react'
import '.././popup.common.css'
import styles from './Style.module.css'
import CustomModal from '../../Modal/CustomModal'
import CustomRadio from '../../CustomRadio/CustomRadio'
import BorderedButton from '../../Buttons/BorderedButton'
import PrimaryButton from '../../Buttons/PrimaryButton'
import { useGlobalContext } from '../../../Context/GlobalContext'

const UpdateRepeatBooking = ({onClose, onCancel, onDiscard}) => {
	const { selectedBookingUpdateScope, setSelectedBookingUpdateScope, editableBooking, setEditedItemData } = useGlobalContext();
	const [selected, setSelected] = useState(selectedBookingUpdateScope || "this_only");
	

	useEffect(() => {
		setSelectedBookingUpdateScope(selected);
	}, [selected, setSelectedBookingUpdateScope]);


	const handleChange = (e) => {
		const value = e.target.value;
		setSelected(value);
	};

	const handleSave = () => {
		if (!selected) {
			return; // Don't save if no option is selected
		}
		// Update editedItemData with the selected scope
		if (editableBooking?.recurring_group_id) {
			setEditedItemData((prev) => ({
				...prev,
				recurring_group_id: editableBooking.recurring_group_id,
				update_scope: selected,
			}));
		}
		// Close the popup - onClose will be called which should allow the update to proceed
		if (onClose) {
			onClose();
		}
	}

	const handleCancel = () => {
		if (onCancel) {
			onCancel();
		} else if (onClose) {
			onClose();
		}
	}



  return (

    <CustomModal
        show={true}
        onHide={onClose}
        hideCloseButton={true}
    >
        <div className={`popup ${styles.updateRepeatBookingPopup}`}>	
            <div className={`${styles.header} header`}>
                <h2>Edit Booking</h2>
            </div>
            <div className="body">
 				<div className={styles.groupInput}>
					<CustomRadio
						label="This Appointment "
						name="customRadio"
						value="this_only"
						checked={selected === "this_only"}
						onChange={handleChange}
					/>
					<CustomRadio
						label="All Future Appointments"
						name="customRadio"
						value="this_and_future"
						checked={selected === "this_and_future"}
						onChange={handleChange}
						disabled={true}
						tag="Coming Soon"
					/>
				</div>
			</div>
            
            <div className={styles.space} />
            <div className="footer">
                <BorderedButton
                    text="Cancel"
                    onClick={handleCancel}
                />
                <PrimaryButton
                    text="Continue"
                    onClick={handleSave}
                />
            </div>
        </div>
  </CustomModal>
  )
}

export default UpdateRepeatBooking